import React, { useState } from 'react';
import Button from './Button';
import PDFDownloadButton from './PDFDownloadButton';
const USER_GUIDE_FILENAME = process.env.REACT_APP_USER_GUIDE_FILE;
const DATA_DICTIONARY_FILENAME = process.env.REACT_APP_RELEASE_BATCH_DICTIONARY_FILE;
const DonwloadLink = () => {
    const [showInstructions, setShowInstructions] = useState(false);
    const [errors, setErrors] = useState([]);

    const addError = (error) => {
        setErrors(prev => [...prev, error]);
    };

    const clearErrors = () => {
        setErrors([]);
    };

    return (
        <div>
            <p className="d-inline-flex gap-1">
                <Button id="btn-hide-show-instructions"
                    text="Show / Hide Instructions"
                    className="btn-secondary"
                    onClick={() => setShowInstructions(!showInstructions)} />
            </p>
            <div>
                {showInstructions && <div className="card card-body">
                    <h4>
                        About
                    </h4>
                    <p>
                        The Medicare Reference Pricer batch pricing dashboard allows multiple claims to be priced to Fee-for-service Medicare at once by uploading a delimited text file with claim detail. All fee schedules and years supported by the single claim Medicare Reference Pricer are supported for batch pricing.
                    </p>
                    <p>
                        Batch pricing will begin automatically once the file is uploaded. The repriced Medicare allowed output data sets will be available for download after processing is complete.
                    </p>
                    <p>
                        Pricing may take up to 5 hours to complete - you do not need to keep this page open after the file upload is finished. You can return at any time to monitor progress and download results.
                    </p>
                    <h4>
                        How to batch price a set of claims:
                    </h4>

                    <ol>
                        <li>
                            <b>Create input claims file</b>: Create a tab delimited text file, following the parameters and specifications outlined in the <i>[inpClaims]</i> section in the
                            <PDFDownloadButton
                                fileName={DATA_DICTIONARY_FILENAME}
                                className="btn-link mb-1 py-0 px-1"
                                buttonText="MRP Data Dictionary - Batch Processing Specification"
                                onError={addError}
                                onClick={clearErrors}
                            /> containing the claims to price. The same input format can be used for all claim types, and all claim types may be placed in the same file. Please see the
                            <PDFDownloadButton
                                fileName={USER_GUIDE_FILENAME}
                                className=" btn-link mb-1 py-0 px-1"
                                buttonText="User Guide"
                                onError={addError}
                                onClick={clearErrors}
                            /> 
                            for additional information. Please ensure that the data is formatted correctly and includes all required fields. Unsupported or malformed data may cause errors. <u>Input data is currently limited to a maximum file size of 100MB per batch.</u>
                        </li>
                        <li>
                            <b>Upload the input claims file</b>: Upload the file via the "Select Batch Data File for Pricing" option and select your text file. Verify that the file name shown matches expectations and press “Upload” to confirm and proceed with the upload. Your file will begin processing. Please see the "Active Batch Processing" list to view detailed status of your batch. Batch processing may take some time and will continue to run if you close this page or browser as long as the upload step completed successfully. You can return to the batch pricing dashboard to monitor progress.
                        </li>
                        <li>
                            <b>Download the outputs</b>: Once the processing completes, click on the Download button for the completed batch in the “Active Batch Processing” list to download the output dataset.  The output data will be provided in a tab delimited text file within a zip file and aligns with the [outClaims] section of the MRP Data Dictionary. The “Delete” button can be used to permanently delete the outputs from the system and remove the batch from the list.
                        </li>
                    </ol>
                    <p>
                        <b>NOTE</b>: Batch results are automatically deleted after four weeks.
                    </p>
                </div>}
            </div>
            {errors.length > 0 && (
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-auto">
                            <ErrorMessage errors={errors.map(error => ({ message: error }))} />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
export default DonwloadLink;
